import { createI18n } from "vue-i18n";

function loadLocaleMessages() {
  const locales = require.context(
    "./locales",
    true,
    /[A-Za-z0-9-_,\s]+\.json$/i
  );
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      const fileContent = locales(key);
      messages[locale] = fileContent;
    }
  });
  return messages;
}

export const locales = [
  {
    id: 1,
    title: "Русский язык",
    shortTitle: "Рус",
    value: "ru",
    locale_id: 1,
    locale: "ru",
  },
  {
    id: 2,
    title: "Қазақ тілі",
    shortTitle: "Қаз",
    value: "kk",
    locale_id: 2,
    locale: "kk",
  },
];

export const getLocaleById = (localeId) => {
  return locales.find((l) => l.locale_id === localeId);
};

const savedLocale = localStorage.getItem("lang") || "ru";

const i18n = createI18n({
  legacy: true,
  locale: savedLocale,
  fallbackLocale: "ru",
  messages: loadLocaleMessages(),
});

export default i18n;
